import { httpService } from "../common/HttpService";

class GamesService {

    constructor() { }

    //getting liveweek
    getLiveWeekGames( fkLeagueId, fkSeasonId, fkWeekId) {
        return httpService.get(`/games/${fkLeagueId}/${fkSeasonId}/${fkWeekId}/liveweekgames`);
    };

   //getting betweek game 
    getBetWeekGames(leagueId, seasonId, weekId) {
        return httpService.get(`/games/${leagueId}/${seasonId}/${weekId}/betweekgames`);
    } 
     
    //getting Results
    getResults(fkLeagueId, fkSeasonId, fkWeekId) {
        return httpService.get(`/games/${fkLeagueId}/${fkSeasonId}/${fkWeekId}/results`);
    }

    //getting super odds
    getSuperOddsList(leagueId, seasonId, weekId) {
        return httpService.get(`/games/${leagueId}/${seasonId}/${weekId}/superodds`);
    }
};

export const gamesService = new GamesService(); 